import styled from 'styled-components';
import { PromoCodeStyled } from '../../PromoCodeStyled';
import { rem } from 'polished';

export const PromoCodeStyledOV = styled(PromoCodeStyled)`
    background: #f2f2f2;

    .promoCode {
        &__title {
            color: ${({ theme }) => theme.colors.black};
            font-size: ${rem(16)};
        }

        &__input_label_success {
            width: 70%;
            left: 15%;
            background: ${({ theme }) => theme.colors.black3};
            color: ${({ theme }) => theme.colors.white};

            &::after {
                border-top: 7px solid ${({ theme }) => theme.colors.black2};
            }
        }

        &__input {
            border: 1px solid ${({ theme }) => theme.colors.grey16};
            color: ${({ theme }) => theme.colors.grey1};

            &_error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &__button {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.primary};
            font-size: ${rem(14)};

            &:hover:enabled {
                color: ${({ theme }) => theme.colors.white};
                background: ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
